import React from 'react'

const AboutTwo = () => {
    const navigateToPlan = () => {
        window.location.href = '/plan';
      }
    return (
        <div>
            <section class="text-gray-600 body-font">
                <div class="container mx-auto flex px-5 py-24 md:flex-row flex-col items-center">
                    <div class="lg:max-w-lg lg:w-full md:w-1/2 w-5/6 mb-10 md:mb-0">
                        <img class="object-cover object-center rounded" alt="hero" src="https://media.istockphoto.com/id/1048405062/photo/young-woman-with-her-personal-trainer-in-the-gym.jpg?s=612x612&w=0&k=20&c=vIy_4_6td86850WOShlywWAPV6xnZIM37nVWj4APZV0=" />
                    </div>
                    <div class="lg:flex-grow md:w-1/2 lg:pl-24 md:pl-16 flex flex-col md:items-start md:text-left items-center text-center">
                        <h1 class="title-font sm:text-4xl text-3xl mb-4 font-medium text-gray-900">Learn Online From Any Device – It’s Easy!
                        </h1>
                        <p class="mb-8 leading-relaxed">
                        Access over 5,000 exercise tutorials and 340+ workout videos anytime, from any device. Train at your own pace, whether at home or in the gym. Capture photos of your progress and share your achievements in our community gallery. Track your fitness journey with engaging tools, challenges, and personalized exercises. Start and stop whenever you need—flexibility is key to your success.
                        </p>
                        <div class="flex justify-center">
                            <button onClick={navigateToPlan} class="inline-flex text-white bg-[#00925D] border-0 py-2 px-6 focus:outline-none hover:bg-[#00925D] rounded text-lg">Enroll Now</button>
                            <button class="ml-4 inline-flex text-gray-700 bg-gray-100 border-0 py-2 px-6 focus:outline-none hover:bg-gray-200 rounded text-lg">Pricing</button>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default AboutTwo